export default __webpack_public_path__ + "static/media/logo-company-8.d0f34277.png";